<template>
  <span class="password_input">
    <input
      class="password_input_inner"
      :readonly="readonly"
      @blur="readonly = newPassword&&true"
      @click="readonly = false"
      v-bind="$attrs"
      @keydown.enter.prevent ="$emit('enter')"
      :type="type"
      v-model="Value"
    />
    <button
      class="showPassword"
      :class="{ cancel: showPassword }"
      @click.prevent="showPassword = !showPassword"
    />
  </span>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  name: 'PasswordInput',
  data() {
    return {
      showPassword: false,
      readonly: true,
    };
  },
  props: {
    value: String,
    newPassword: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.readonly = this.newPassword;
  },
  computed: {
    type() {
      return this.showPassword ? 'text' : 'password';
    },
    Value: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/mixin.less";

.password_input {
  position: relative;
  width: 100%;
  .password_input_inner {
    width: 100%;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    border: 1px solid rgba(192, 192, 192, 1);
    outline: none;
    padding: 19px;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 14px;
  }
  .showPassword {
    position: absolute;
    line-height: 40px;
    right: 20px;
    display: inline-block;
    .bg-img("~@/assets/images/eye_closed");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    top: 0;
    bottom: 0;
    margin: auto;
    border: none;
    width: 13px;
    height: 7px;
    outline: none;
    &.cancel {
      .bg-img("~@/assets/images/eye_open");
      height: 9px;
    }
  }
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px rgba(255, 253, 246, 0) inset;
  -webkit-text-fill-color: #7e7e7e;
}
input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 100px rgba(255, 253, 246, 1) inset;
  -webkit-text-fill-color: #7e7e7e;
}
/deep/input::-webkit-input-placeholder {
  color: #7e7e7e;
}
/deep/input {
  color: #7e7e7e;
  padding: 0 13px;
  width: 264px;
  height: 32px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(190, 190, 190, 1);
  border-radius: 6px;
  outline: none;
  &:focus {
    background: rgba(255, 253, 246, 1);
  }
}
</style>
